import { object, string } from "yup"
import { isValidPhoneNumber } from "react-phone-number-input"

// Helpers
import { alphanumericRegex } from "@4cplatform/elements/Helpers"
import { validNameRegex, validPostcodeRegex } from "../../Helpers"

export const createNetworkModel = object({
  name: string().required("MISSING_REQUIRED_FIELD").nullable(),
  description: string().required("MISSING_REQUIRED_FIELD").nullable(),
  company_registration_number: string()
    .required("MISSING_REQUIRED_FIELD")
    .test("alphanumeric", "INVALID_ALPHANUMERIC", no => alphanumericRegex.test(no))
    .nullable(),
  fca_reference: string()
    .required("MISSING_REQUIRED_FIELD")
    .test("fcaReference", "ONLY_DIGITS_ALLOWED", ref => /^\d+$/.test(ref))
    .min(6)
    .max(7),
  phone_number: string()
    .required("MISSING_REQUIRED_FIELD")
    .test("Phone invalid", "INVALID_PHONE", val => {
      if (!val) return false
      return isValidPhoneNumber(val, "GB")
    }),
  contact_first_name: string()
    .required("MISSING_REQUIRED_FIELD")
    .test("validNameTest", "INVALID_NAME", name => validNameRegex.test(name))
    .nullable(),
  contact_last_name: string()
    .required("MISSING_REQUIRED_FIELD")
    .test("validNameTest", "INVALID_NAME", name => validNameRegex.test(name))
    .nullable(),
  contact_email_address: string()
    .required("MISSING_REQUIRED_FIELD_WITH_PREFIX_EMAIL")
    .email()
    .nullable(),
  address: object({
    postcode: string()
      .test("correctUkPostcode", "CORRECT_UK_POSTCODE", no => validPostcodeRegex.test(no))
      .required("MISSING_REQUIRED_FIELD")
      .nullable(),
    line_one: string().required("MISSING_REQUIRED_FIELD").nullable(),
    line_two: string().nullable(),
    city: string().required("MISSING_REQUIRED_FIELD").nullable(),
    county: string().required("MISSING_REQUIRED_FIELD").nullable()
  })
})
